import { createStore, applyMiddleware } from 'redux';
import { createEpicMiddleware } from 'redux-observable';
import rootEpic  from './epics';
import rootReducer from './reducers';
 
const epicMiddleware = createEpicMiddleware();

export default function configureStore(initialState) {
  const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__;
  
  const store = createStore(
    rootReducer,
    initialState,
    applyMiddleware(epicMiddleware)
    //composeEnhancers(applyMiddleware(epicMiddleware))
  );
 
  epicMiddleware.run(rootEpic);
 
  return store;
}